export default "__VITE_ASSET__DaVLveV6__"